import { __extends, __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { Component } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import '../../../reset/HtmlA/HtmlA.js';
import '../../../reset/HtmlButton/HtmlButton.js';
import { HtmlDiv } from '../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../reset/HtmlH/HtmlH.js';
import '../../../reset/HtmlInput/HtmlInput.js';
import '../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../reset/HtmlLi/HtmlLi.js';
import '../../../reset/HtmlNav/HtmlNav.js';
import '../../../reset/HtmlOl/HtmlOl.js';
import '../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../../reset/HtmlUl/HtmlUl.js';
import '../../../reset/HtmlTable/HtmlTable.js';
import '../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../reset/HtmlTable/HtmlTableCell.js';
import { baseClassName, ModalConsumer } from '../Modal/Modal.js';
import { baseStyles } from './ModalContent.baseStyles.js';
import { SuomifiThemeConsumer } from '../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../theme/SuomifiTheme/SuomifiTheme.js';
import '../../theme/SpacingProvider/SpacingProvider.js';

var contentClassName = "".concat(baseClassName, "_content");
var modalContentClassNames = {
  smallScreen: "".concat(contentClassName, "--small-screen"),
  noScroll: "".concat(contentClassName, "--no-scroll"),
  heading: "".concat(contentClassName, "_heading")
};
var BaseModalContent = function (_super) {
  __extends(BaseModalContent, _super);
  function BaseModalContent() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BaseModalContent.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className;
      _b.theme;
      _b.title;
      var children = _b.children,
      scrollable = _b.scrollable,
      modalVariant = _b.modalVariant,
      passProps = __rest(_b, ["className", "theme", "title", "children", "scrollable", "modalVariant"]);
    return /*#__PURE__*/React.createElement(HtmlDiv, __assign({
      className: classnames(contentClassName, className, (_a = {}, _a[modalContentClassNames.noScroll] = scrollable === false, _a[modalContentClassNames.smallScreen] = modalVariant === 'smallScreen', _a))
    }, passProps), children);
  };
  return BaseModalContent;
}(Component);
var StyledModalContent = styled(BaseModalContent).withConfig({
  componentId: "sc-1h0ki9i-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return baseStyles(theme);
});
var ModalContent = function ModalContent(props) {
  return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
    var suomifiTheme = _a.suomifiTheme;
    return /*#__PURE__*/React.createElement(ModalConsumer, null, function (_a) {
      var variant = _a.variant,
        scrollable = _a.scrollable;
      return /*#__PURE__*/React.createElement(StyledModalContent, __assign({
        theme: suomifiTheme,
        modalVariant: variant,
        scrollable: scrollable
      }, props));
    });
  });
};
ModalContent.displayName = 'ModalContent';
var templateObject_1;

export { ModalContent };
//# sourceMappingURL=ModalContent.js.map
